import { assign, flow, map, sortBy } from 'lodash/fp';

import prepareOptions from '../../prepareOptions';
import { CRUISE_CONTROL, FOUR_WHEEL_DRIVE } from '../security';
import { HIGH_BEAM_ASSISTANT, XENON_HEADLIGHTS } from '../light';
import { AIR_SUSPENSION, AIR_CONDITION, AUXILIARY_HEATING } from '../comfort';
import { HANDS_FREE_KIT, NAVIGATION_SYSTEM } from '../multimedia';
import {
  ELECTRIC_HEATED_SEATS,
  ELECTRIC_SIDE_MIRROR,
  ELECTRIC_WINDOWS,
  HEAD_UP_DISPLAY,
} from '../interior';
import { PANORAMIC_ROOF, TRAILER_HITCH } from '../extra';
import {
  REAR as SENSORS_REAR,
  FRONT as SENSORS_FRONT,
  CAMERA as SENSORS_CAMERA,
} from '../parkingSensor';
import {
  COMFORT_NAME,
  EXTRAS_NAME,
  MULTIMEDIA_NAME,
  INTERIOR_NAME,
  LIGHT_NAME,
  PARKING_SENSORS_NAME,
  SECURITY_NAME,
} from './names';

const prepareOptionsWithName = (name, options) =>
  flow(map(assign({ fieldName: name })), prepareOptions)(options);

const comfortOptions = prepareOptionsWithName(COMFORT_NAME, [
  {
    value: AIR_CONDITION,
    label: __('carDetails.equipmentGroups.airCondition'),
  },
  {
    value: AIR_SUSPENSION,
    label: __('carDetails.equipmentGroups.airSuspension'),
  },
  {
    value: AUXILIARY_HEATING,
    label: __('carDetails.equipmentGroups.auxiliaryHeater'),
  },
]);

const extraOptions = prepareOptionsWithName(EXTRAS_NAME, [
  {
    value: TRAILER_HITCH,
    label: __('carDetails.equipmentGroups.trailerHitch'),
  },
  {
    value: PANORAMIC_ROOF,
    label: __('carDetails.equipmentGroups.panoramicRoof'),
  },
]);

const multimediaOptions = prepareOptionsWithName(MULTIMEDIA_NAME, [
  {
    value: HANDS_FREE_KIT,
    label: __('carDetails.equipmentGroups.handsFreeSystem'),
  },
  {
    value: NAVIGATION_SYSTEM,
    label: __('carDetails.equipmentGroups.navigationSystem'),
  },
]);

const interiorOptions = prepareOptionsWithName(INTERIOR_NAME, [
  {
    value: ELECTRIC_HEATED_SEATS,
    label: __('carDetails.equipmentGroups.heatedSeats'),
  },
  {
    value: ELECTRIC_SIDE_MIRROR,
    label: __('carDetails.equipmentGroups.sideViewMirrors'),
  },
  {
    value: ELECTRIC_WINDOWS,
    label: __('carDetails.equipmentGroups.heatedFrontWindow'),
  },
  {
    value: HEAD_UP_DISPLAY,
    label: __('carDetails.equipmentGroups.headUpDisplay'),
  },
]);

const lightOptions = prepareOptionsWithName(LIGHT_NAME, [
  {
    value: HIGH_BEAM_ASSISTANT,
    label: __('carDetails.equipmentGroups.highbeamAssistant'),
  },
  {
    value: XENON_HEADLIGHTS,
    label: __('carDetails.equipmentGroups.xenonLights'),
  },
]);

const parkingSensorOptions = prepareOptionsWithName(PARKING_SENSORS_NAME, [
  {
    value: SENSORS_REAR,
    label: __('search.parkingAssistanceType.rear'),
  },
  {
    value: SENSORS_FRONT,
    label: __('search.parkingAssistanceType.frontAndRear'),
  },
  {
    value: SENSORS_CAMERA,
    label: __('carDetails.parkingAssistanceType.rearCamera'),
  },
]);

const securityOptions = prepareOptionsWithName(SECURITY_NAME, [
  {
    value: CRUISE_CONTROL,
    label: __('carDetails.equipmentGroups.adoptiveCruiseControl'),
  },
  {
    value: FOUR_WHEEL_DRIVE,
    label: __('carDetails.equipmentGroups.allWheelDrive'),
  },
]);

const options = [
  ...comfortOptions,
  ...extraOptions,
  ...interiorOptions,
  ...lightOptions,
  ...multimediaOptions,
  ...parkingSensorOptions,
  ...securityOptions,
];

export default flow(sortBy(({ label }) => label))(options);
